import IframeContainer from "./IframeContainer";

const renderYoutube = (uri: string) => {
  return (
    <IframeContainer>
      <iframe
        title="Youtube video"
        src={uri}
        allow="accelerometer; encrypted-media; gyroscope; picture-in-picture"
        style={{ border: "none" }}
        allowFullScreen
      ></iframe>
    </IframeContainer>
  );
};

export const youtubeRenderer = {
  renderYoutube,
};
